import React from "react";
import { Paper } from "@mui/material";
import { useIconFieldStyles } from "./css";
import Grid from "@mui/material/Grid2";

interface IIconField {
  title: React.ReactNode;
  icon: React.ReactNode;
  onClick?: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent> | undefined
  ) => void;
  disabled?: boolean;
  greenText?: boolean;
  noMargin?: boolean;
}

function IconField(props: IIconField) {
  const { icon, title, onClick, disabled, greenText = false, noMargin } = props;
  const { classes, cx } = useIconFieldStyles();

  return (
    <div>
      <Grid container direction="column" wrap="nowrap">
        <Grid container direction="row">
          <Paper
            elevation={0}
            classes={{
              root: cx(classes.root, { [classes.noMargin]: noMargin }),
            }}
            square
            onClick={onClick}
          >
            <Grid
              container
              spacing={1}
              direction="row"
              wrap="nowrap"
              alignItems="center"
              className={cx({
                [classes.disabled]: disabled === true,
                [classes.greenText]: greenText,
              })}
            >
              {icon}
              {title}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default IconField;
